import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppQuickView from './AppQuickView'
import AppDetailedView from './AppDetailedView'

class AppDisplayInfo extends Component {

  static propTypes = {
    appId: PropTypes.string.isRequired,
    isFetchingApp: PropTypes.bool.isRequired,
    showErrorNotification: PropTypes.func.isRequired,
    fetchApp: PropTypes.func.isRequired,
    app: PropTypes.shape({
      name: PropTypes.string,
      shortDescription: PropTypes.string,
      longDescription: PropTypes.string,
      iconUrl: PropTypes.string
    })
  }

  componentWillUnmount() {
    const { fetchApp } = this.props
    fetchApp()
  }

  render() {
    const { appId, showErrorNotification, isFetchingApp, app } = this.props

    return (
      <div className="app-info">
        <span className="page-title">
          Display Information
        </span>
        <p className="page-description">
          This is how your app will be shown in Drift. Check out our App Display Guidelines for templates and more information.
        </p>
        <AppQuickView
          isLoading={isFetchingApp}
          appId={appId}
          app={app}
          showErrorNotification={showErrorNotification}
        />
        <AppDetailedView
          isLoading={isFetchingApp}
          appId={appId}
          app={app}
          showErrorNotification={showErrorNotification}
        />
      </div>
    )
  }
}

export default AppDisplayInfo
